{
  "name": "@ns/form",
  "version": "1.0.0",
  "authorable": true,
  "description": "A form someone fills in: the node's config lists its questions, and the answers come back keyed by question.",
  "inputs": {
    "CONFIG": {
      "type": "object"
    }
  },
  "outcomes": {
    "submit": {
      "inputs": {
        "ANSWERS": {
          "type": "object"
        }
      }
    },
    "decline": {
      "inputs": {
        "ANSWERS": {
          "type": "object"
        }
      }
    }
  },
  "config": {
    "intro": {
      "kind": "longText",
      "label": "Introduction"
    },
    "fields": {
      "kind": "custom",
      "editor": "form-fields",
      "label": "Questions",
      "required": true
    }
  },
  "answers": {
    "submit": {
      "fieldsOf": "fields"
    },
    "decline": {
      "reason": {
        "kind": "longText"
      }
    }
  }
}
